import React, { Component } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Placeholder } from 'components';
import './style.scss';
import PaymentMethodMappedParams from 'lib/utils/mappers/hpp/PaymentMethodMappedParams';
import { compose } from 'redux';
import withLaunchDarkly from 'hocs/withLaunchDarkly';

class TuitionExpressCard extends Component {
  static propTypes = {
    data: PropTypes.object,
    onClose: PropTypes.func,
    flags: PropTypes.object
  };

  static defaultProps = {
    data: {
      uriMethod: 'teAccountUri'
    }
  };

  constructor(...args) {
    super(...args);
    this.state = {
      teraSetting: null,
      teraLoading: true
    };
  }

  componentDidMount() {
    const {
      data: { uriMethod },
      flags
    } = this.props;

    this.setState({ teraLoading: true });
    req[uriMethod]()
      .then(teraSetting => {
        this.setState({ teraLoading: false, teraSetting }, () => {
          if (flags['te-vnext']) {
            this.initializeHPP();
          } else {
            this.initializeTera();
          }
        });
      })
      .catch(e => {
        this.setState({ teraLoading: false, teraSetting: null });
        Actions.reportError('There was problem getting Tuition Express token', e);
      });
  }

  @bind
  onTeraLoaded() {
    this.setState({ teraLoading: false });
  }

  @bind
  initializeTera() {
    const { TeraUrl, Token, ProfileID } = this.state.teraSetting;
    this.tera = new window.tera({
      Target: 'payment_container',
      TeraUrl,
      Token,
      ProfileID,
      Style: `${process.env.PUBLIC_PATH}/assets/tera.css`,
      Height: 500,
      OnLoaded: this.onTeraLoaded,
      OnSuccess: this.handleSubmit,
      OnResponse: noop,
      OnDecline: console.log,
      OnError: console.log,
      OnValidation: console.log,
      SaveOnly: true
    });
    this.tera.Initialize(9.99);
  }

  @bind
  initializeHPP() {
    const { TeraUrl, Token, ProfileID, MerchantID } = this.state.teraSetting;
    this.hpp = new window.hpp({
      Target: 'payment_container',
      HPPUrl: TeraUrl,
      MerchantId: MerchantID,
      Token: Token,
      ProfileId: ProfileID,
      InitialPaymentType: 'CC',
      ShowPaymentTypeCc: true,
      ShowPaymentTypeAch: false,
      Height: 500,
      OnLoaded: this.onTeraLoaded,
      OnSuccess: this.handleHPPMapping,
      OnResponse: noop,
      OnDecline: console.log,
      OnError: console.log,
      OnValidation: console.log,
      SaveOnly: true
    });
    this.hpp.Initialize(9.99);
  }

  @bind
  handleHPPMapping(data) {
    const mappedParams = new PaymentMethodMappedParams(data);

    this.handleSubmit(JSON.stringify(mappedParams));
  }

  @bind
  handleSubmit(data) {
    const { onClose } = this.props;

    onClose(data);
  }

  render() {
    const { teraSetting, teraLoading } = this.state;

    return (
      <div className="modal__wrapper tuition-express-modal">
        <div className="modal__header modal__header--bordered">
          <div className="modal__header-title">Add Card Info</div>
        </div>

        <div className="modal__container">
          <div id="payment_container" />
          {(!teraSetting || teraLoading) && (
            <Placeholder.NoResult isLoading image="" className="te-payments__placeholder">
              <div className="no-payments__title">There was problem getting Tuition Express token.</div>
            </Placeholder.NoResult>
          )}
        </div>
      </div>
    );
  }
}

const enhance = compose(withLaunchDarkly);

export default enhance(TuitionExpressCard);
